import {keepPreviousData, useQuery} from '@tanstack/react-query';
import {apiClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {useParams} from 'react-router-dom';
import {Title} from '@app/titles/models/title';
import {Episode} from '@app/titles/models/episode';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {Lien} from '@app/titles/models/lien';

export interface UseDownloadPageResponse extends BackendResponse {
  related_videos: Lien[];
  title: Title;
  episode?: Episode;
  video: Lien;
  alternative_videos: Lien[];
  last_episode?: {episode: number};
  seasons?: {
    id: number;
    number: number;
    episode_count: number;
  }[];
  full_saison?: boolean;
}

export function useDownloadGetTitle(seasonParam?: number) {
  const {titleId, episode} = useParams();

  return useQuery<UseDownloadPageResponse>({
    queryKey: ['title', titleId, seasonParam, episode].filter(Boolean), // seasonParam ici !
    queryFn: () =>
      fetchVideo(
        Number(titleId),
        seasonParam ? Number(seasonParam) : undefined,
        Number(episode),
      ),
    placeholderData: keepPreviousData,
    initialData: () => {
      return getBootstrapData().loaders?.downloadPage;
    },
  });
}

function fetchVideo(titleId?: number, season?: number, episode?: number) {
  if (episode) {
    return apiClient
      .get<UseDownloadPageResponse>(
        `titles/${titleId}/season/${season}/episode/${episode}/download`,
      )
      .then(response => response.data);
  }
  return apiClient
    .get<UseDownloadPageResponse>(`titles/${titleId}/download`)
    .then(response => response.data);
}
